/* global File */

export class RenameFileHelper {
  static renameFile (file, name) {
    return new File([file], name, { type: file.type });
  }
}
